import { render, staticRenderFns } from "./energyArea.vue?vue&type=template&id=d83a1378&scoped=true&"
import script from "./energyArea.vue?vue&type=script&lang=js&"
export * from "./energyArea.vue?vue&type=script&lang=js&"
import style0 from "./energyArea.vue?vue&type=style&index=0&id=d83a1378&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d83a1378",
  null
  
)

export default component.exports